import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'
import { AppState } from './types'

export const getters: GetterTree<AppState, RootState> = {
  menuopen: ({ menuopen }) => menuopen,
  cookies: ({ cookies }) => cookies,
  loaded: ({ loaded }) => loaded,
}
